export class CertificateRequestData {

  public certificateB64: string;

  constructor() {

  }
}
